export default "__VITE_ASSET__099f9991__"